module.exports = __webpack_public_path__ + "css/img/i-map-marker-red.e946d421d53e6d580def7315842174ab.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/_img/i-map-marker-red.svg
// module id = 303
// module chunks = 0